package com.example.mystybag.lib.setup

import androidx.compose.material3.ColorScheme
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color

object MystyBagLibSDK {

    var lightColorScheme    : ((colors: ColorScheme)                        -> ColorScheme)?            = null
    var darkColorScheme     : ((colors: ColorScheme)                        -> ColorScheme)?            = null
    var customColors        : ((colors: ColorScheme)                        -> AppCustomColors)?        = null
    var customGradients     : (()                                           -> AppCustomGradients)?     = null
    var navigationColors    : ((colors: ColorScheme, isDarkMode: Boolean)   -> NavigationCustomColors)? = null

    var appKey              : String    = ""
    /** Used for GET https://api.companybook.bg (merchant registration BULSTAT lookup). Obtain at https://companybook.bg/api-docs */
    var companyBookApiKey   : String    = ""
    var appLabel            : String    = ""
    var logoResource        : Any?      = null
    var homeButtonResource  : Any?      = null
    var isDarkMode          : Boolean?  = null

    var emailSubject        : (() -> String)? = null
}

data class NavigationCustomColors(
    var statusBarBackground         : Color,
    var topNavigationBarBackground  : Color,
    var statusBarContent            : Color,
    var navigationBar               : Color,
    var statusBarDarkIcon           : Boolean,
    var navigationBarDarkIcon       : Boolean
) {
    constructor(colors: ColorScheme, isDarkMode: Boolean) : this(
        statusBarBackground         = colors.surfaceDim,
        topNavigationBarBackground  = colors.surfaceDim,
        statusBarContent            = colors.onSurface,
        navigationBar               = colors.surfaceDim,
        statusBarDarkIcon           = !isDarkMode,
        navigationBarDarkIcon       = !isDarkMode
    )
}

data class AppCustomColors(
    var amountGreen             : Color,
    var alertOrange             : Color,
    var vividBlue               : Color,
    var vividRed                : Color,
    var vividGreen              : Color,
    var vividPurple             : Color,
    var vividYellow             : Color,
    var widgetLabelColor        : Color,
    var headerRowFirstTitle     : Color,
    var headerRowSecondTitle    : Color,
    var rippleColor             : Color,
    var blueToWhite             : Color,
    var greenToBlue             : Color,
    var redToWhite              : Color,
    var lightGrayToDarkBlue     : Color
) {
    constructor(colors: ColorScheme) : this(
        amountGreen          = Color(0xFF64A180),
        alertOrange          = Color(0xFFCF9D47),
        vividBlue            = Color(0xFF2D5BE2),
        vividRed             = Color(0xFFDE3965),
        vividGreen           = Color(0xFF07B78D),
        vividPurple          = Color(0xFF8068D2),
        vividYellow          = Color(0xFFF8A90B),
        blueToWhite          = colors.primary,
        greenToBlue          = Color(0xFF64A180),
        redToWhite           = colors.error,
        lightGrayToDarkBlue  = colors.surface,
        widgetLabelColor     = colors.onSurface,
        headerRowFirstTitle  = colors.onSurface,
        headerRowSecondTitle = colors.onSurfaceVariant,
        rippleColor          = colors.primary
    )
}

data class AppCustomGradients(
    var yellowGradient  : Brush,
    var greenGradient   : Brush,
    var blueGradient    : Brush,
    var purpleGradient  : Brush,
    var darkGradient    : Brush
) {
    constructor(): this(
        yellowGradient  = Brush.horizontalGradient(colorStops  = arrayOf(0.0f to Color(0xFFE59927), 1f to Color(0xFFF5CF49))),
        greenGradient   = Brush.horizontalGradient(colorStops  = arrayOf(0.0f to Color(0xFF38B177), 1f to Color(0xFF3DD6B1))),
        blueGradient    = Brush.horizontalGradient(colorStops  = arrayOf(0.0f to Color(0xFF5492EE), 1f to Color(0xFF54C9EE))),
        purpleGradient  = Brush.horizontalGradient(colorStops  = arrayOf(0.0f to Color(0xFF7B86EE), 1f to Color(0xFFA892EE))),
        darkGradient    = Brush.horizontalGradient(colorStops  = arrayOf(0.0f to Color(0xFF333333), 1f to Color(0xFF252525)))
    )
}